"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rule_constants_1 = require("./rule-constants");
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.empty,
    elementId: ''
};
//# sourceMappingURL=element-condition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/element-condition.js
// module id = 1112
// module chunks = 0